import type { IntlShape, LocaleKey } from './context';

/** 按一份语言包造 formatMessage：I18nProvider 与 React 之外的 translate 共用这一份插值口径 */
export function createIntl(
  locale: LocaleKey,
  messages: Record<string, string>,
): IntlShape {
  return {
    locale,
    messages,
    formatMessage: ({ id, defaultMessage }, values) => {
      const template = messages[id] ?? defaultMessage ?? id;
      if (!values) return template;
      return template.replace(/\{(\w+)\}/g, (_, key) =>
        values[key] === undefined ? `{${key}}` : String(values[key]),
      );
    },
  };
}

let current: IntlShape | null = null;

/** I18nProvider 每拿到一份语言包就登记一次；请求拦截器、store 这些 React 之外的地方从这里取词条 */
export function bindIntl(intl: IntlShape): void {
  current = intl;
}

/** React 之外取词条。语言包还没到时回键名本身，与 formatMessage 找不到键时同一口径 */
export function translate(
  id: string,
  values?: Record<string, unknown>,
): string {
  return current ? current.formatMessage({ id }, values) : id;
}
